import { render } from "./SmilesPreview.vue?vue&type=template&id=3940f5bc&scoped=true"
import script from "./SmilesPreview.vue?vue&type=script&lang=js"
export * from "./SmilesPreview.vue?vue&type=script&lang=js"

import "./SmilesPreview.vue?vue&type=style&index=0&id=3940f5bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3940f5bc"]])

export default __exports__